function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPattern2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "960px",
    height: "19px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#175ca8",
    d: "M -0.5,0.5 C 110.833,0.5 222.167,0.5 333.5,0.5C 333.5,6.5 333.5,12.5 333.5,18.5C 222.167,18.5 110.833,18.5 -0.5,18.5C -0.5,12.5 -0.5,6.5 -0.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#28b352",
    d: "M 333.5,0.5 C 435.833,0.5 538.167,0.5 640.5,0.5C 640.5,6.5 640.5,12.5 640.5,18.5C 538.167,18.5 435.833,18.5 333.5,18.5C 333.5,12.5 333.5,6.5 333.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0a635",
    d: "M 640.5,0.5 C 746.833,0.5 853.167,0.5 959.5,0.5C 959.5,6.5 959.5,12.5 959.5,18.5C 853.167,18.5 746.833,18.5 640.5,18.5C 640.5,12.5 640.5,6.5 640.5,0.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern2);
export default __webpack_public_path__ + "static/media/pattern-2.eab20d027a13a647236839471b8fd135.svg";
export { ForwardRef as ReactComponent };